import Swiper, { Autoplay, Pagination } from 'swiper'
import ModalVideo from '../partials/modal-video'

const Slider = () => {
  const swiper = new Swiper('.slider-component', {
    modules: [Autoplay, Pagination],
    // autoplay: {
    //   delay: 3500,
    //   disableOnInteraction: false,
    // },
    pagination: {
      el: '.slider-pagination',
      clickable: true,
    },
  })

  let dataVideo = document.querySelectorAll('[data-videoid]')

  dataVideo.forEach((el) => {
    el.addEventListener('click', () => {
      const urlVideo = el.dataset.videoid
      new ModalVideo(urlVideo)
    })
  })
}

export default Slider
